import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IFile, IFileUpload } from '../interfaces/File.js';

class File extends ABaseModel implements IFile {
  id: number;
  status: number;
  public: boolean;
  mimeType: string;
  key: string;
  extension: string;
  size: number;
  signedUri?: string;
}

/**
 * FileUpload
 */
class FileUpload extends ABaseModel implements IFileUpload {
  transactionId: string;
  transactionStage: string;
  transactionStatus: string;
  transactionProgress: number;
  transactionFiles: number[];
  transactionErrorCode: string;
  transactionErrorMessage: string;
  uploadUrl: string;
}

export { File, FileUpload };
